// fixedBody.js
const scrollState = {
	position: 0,
	bodyWidth: '',
	isFixed: false,
	originalStyles: null,
}

export const fixedBody = () => {
	if (scrollState.isFixed) return

	scrollState.position = window.pageYOffset || window.scrollY

	// 現在のbodyのスタイルを保存
	scrollState.originalStyles = {
		position: document.body.style.position,
		top: document.body.style.top,
		left: document.body.style.left,
		width: document.body.style.width,
		overflow: document.body.style.overflow,
	}

	// スクロールバーの幅を考慮
	const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth
	const bodyWidth = `calc(100% - ${scrollbarWidth}px)`

	$('body').css({
		position: 'fixed',
		top: `-${scrollState.position}px`,
		left: '0',
		width: bodyWidth,
		overflow: 'hidden',
	})

	scrollState.isFixed = true
}

export const unFixedBody = () => {
	if (!scrollState.isFixed) return

	// 元のスタイルに戻す
	$('body').css(scrollState.originalStyles)

	// スクロール位置を復元
	window.scrollTo(0, scrollState.position)

	// 状態をリセット
	scrollState.isFixed = false
	scrollState.position = 0
	scrollState.originalStyles = null
}

// エラーケース用の強制リセット関数を追加
export const forceResetBody = () => {
	$('body').css({
		position: '',
		top: '',
		left: '',
		width: '',
		overflow: '',
	})
	scrollState.isFixed = false
	scrollState.position = 0
	scrollState.originalStyles = null
}
